import {doc, getDoc, setDoc, serverTimestamp} from "firebase/firestore";
import {db} from "../../firebase";

const SETTINGS_COLLECTION = "storeSettings";
const SHIPPING_DOCUMENT = "shipping";
const PROPERTIES_DOCUMENT = "properties";

export default class StoreSettingsAPI {
  async getShippingSettings() {
    try {
      const snapshot = await getDoc(doc(db, SETTINGS_COLLECTION, SHIPPING_DOCUMENT));
      return {
        success: true,
        data: snapshot.exists() ? snapshot.data() : {},
      };
    } catch (error) {
      console.log("StoreSettingsAPI getShippingSettings error:", error);
      return {success: false, message: error};
    }
  }

  async setShippingSettings({freeShippingAbove, deliveryFee}) {
    try {
      await setDoc(
        doc(db, SETTINGS_COLLECTION, SHIPPING_DOCUMENT),
        {freeShippingAbove, deliveryFee, updatedAt: serverTimestamp()},
        {merge: true}
      );
      return {success: true};
    } catch (error) {
      console.log("StoreSettingsAPI setShippingSettings error:", error);
      return {success: false, message: error};
    }
  }

  async getPropertiesSectionSettings() {
    try {
      const snapshot = await getDoc(doc(db, SETTINGS_COLLECTION, PROPERTIES_DOCUMENT));
      return {
        success: true,
        data: snapshot.exists() ? snapshot.data() : { isEnabled: true },
      };
    } catch (error) {
      console.log("StoreSettingsAPI getPropertiesSectionSettings error:", error);
      return {success: false, message: error};
    }
  }

  async setPropertiesSectionSettings({ isEnabled }) {
    try {
      await setDoc(
        doc(db, SETTINGS_COLLECTION, PROPERTIES_DOCUMENT),
        { isEnabled: Boolean(isEnabled), updatedAt: serverTimestamp() },
        { merge: true }
      );
      return {success: true};
    } catch (error) {
      console.log("StoreSettingsAPI setPropertiesSectionSettings error:", error);
      return {success: false, message: error};
    }
  }
}

